import React, { useMemo } from 'react';
import { useStoreState } from '@proscom/prostore-react';
import { AbsenceType } from '../../../../graphql/types';
import { AbsenceTypesStoreState } from '../../../../store/AbsenceTypesStore';

export interface AbsencesProps {
  showPositions?: boolean;
  absences?: AbsenceType[] | null;
  isAlign?: boolean;
}

export const Absences: React.FC<AbsencesProps> = ({ absences, isAlign }) => {
  const { absenceTypes } = useStoreState<AbsenceTypesStoreState>(
    'STORE_ABSENCE_TYPES'
  );

  const vacationTypeMapping = useMemo(() => {
    return absenceTypes;
  }, [absenceTypes]);

  const absencesByPosition = {};

  absences?.forEach((absence) => {
    if (absencesByPosition[absence.position]) {
      absencesByPosition[absence.position].push(absence);
    } else {
      absencesByPosition[absence.position] = [absence];
    }
  });

  const style = useMemo(() => {
    if (isAlign) {
      return { width: 200 };
    } else {
      return {};
    }
  }, [isAlign]);

  return (
    <div style={style}>
      {Object.keys(absencesByPosition).map((position) => {
        const vacations = absencesByPosition[position];

        const positionAbsenceInfo = vacations.map((vacation) => {
          let color = '';
          let vacationDisplayName = vacation.name;
          const vacData = vacationTypeMapping.filter(
            (vacationType) => vacationType.name === vacation.name
          );

          if (vacData && vacData.length && vacData[0]) {
            const vacationTypeData = vacData[0];

            if (vacationTypeData.color) {
              color = vacationTypeData.color;
            }

            let displayName = '';
            if (vacationTypeData.category) {
              displayName = vacationTypeData.category;
            }

            // если категория отпуск, то выводим подкатегорию (поле checkbox)
            if (
              vacationTypeData.category === 'Отпуск' &&
              vacationTypeData.checkbox !== 'Не детализируется'
            ) {
              displayName = vacationTypeData.checkbox;
            }

            if (displayName) {
              vacationDisplayName = displayName;
            }
            // для дистанционной работы цвет в списке не приходит, придумываем сами по ТЗ
          } else if (vacation.isRemote) {
            color = '#ff870b';
          }

          const startDate = vacation.dateStart
            ? vacation.dateStart.split(' ')[0]
            : '';
          const endDate = vacation.dateEnd
            ? vacation.dateEnd.split(' ')[0]
            : '';

          return (
            <div key={position + vacationDisplayName}>
              <span style={{ color: color }}>
                {vacationDisplayName}{' '}
                {!vacation.isRemote && (
                  <>
                    {isAlign ? <br></br> : null}
                    <span>
                      {startDate}-{endDate}
                    </span>
                  </>
                )}
              </span>
            </div>
          );
        });

        return (
          <div key={position}>
            {position}
            {positionAbsenceInfo}
          </div>
        );
      })}
    </div>
  );
};
